<!-- This is the Duty Activity Display -->
<template>
  <div
    :style="style"
    style="width: 100%"
    class="DutyActivity d-flex flex-column"
    :class="`${showBottomBorder ? `item-bottom-border` : ''} ${isParent ? 'duty-activity-parent' : `duty-activity-child-${themeName}`}`"
  >
    <component
      :is="titleComponent"
      :isParent="isParent"
      :duty="duty"
      :dutyActivity="dutyActivity"
      :themeName="themeName"
      :config="moduleConfig"
      @onSelectAllLine="$emit('onDutyActivityLineSelected', dutyActivity)"
      @onSelectDutyActivity="$emit('onDutyActivitySelected', dutyActivity)"
      @displayTrainTeam="displayTrainTeam"
      :hasTrueChildren="hasTrueChildren"
    ></component>

    <component
      v-if="hasStartIdentifier"
      :is="startComponent"
      :isParent="isParent"
      :dutyActivity="dutyActivity"
      :timeFormat="timeFormat"
      :config="moduleConfig"
      :themeName="themeName"
      :dutyStopsById="dutyStopsById"
      :hasTrueChildren="hasTrueChildren"
      @displayTrainTeam="displayTrainTeam"
    ></component>

    <component
      v-if="!hasStartIdentifier && !dutyActivity.line"
      :is="noLineStartComponent"
      :isParent="isParent"
      :dutyActivity="dutyActivity"
      :timeFormat="timeFormat"
      :config="moduleConfig"
      :themeName="themeName"
      :dutyStopsById="dutyStopsById"
      :hasTrueChildren="hasTrueChildren"
    ></component>

    <component
      v-if="!dutyActivity.line && !hasEndIdentifier"
      :is="noLineEndComponent"
      :isParent="isParent"
      :dutyActivity="dutyActivity"
      :timeFormat="timeFormat"
      :config="moduleConfig"
      :themeName="themeName"
      :dutyStopsById="dutyStopsById"
      :hasTrueChildren="hasTrueChildren"
    ></component>

    <component
      v-if="hasEndIdentifier"
      :is="endComponent"
      :isParent="isParent"
      :dutyActivity="dutyActivity"
      :nextDutyActivity="nextDutyActivity"
      :timeFormat="timeFormat"
      :config="moduleConfig"
      :themeName="themeName"
      :dutyStopsById="dutyStopsById"
      :hasTrueChildren="hasTrueChildren"
    ></component>
    <div v-if="hasTrueChildren" class="d-flex align-self-end" @click.prevent.stop="toggleDutyActivity">
      <v-icon color="error">mdi-chevron-{{ isCollapsedInternal ? 'down' : 'up' }}</v-icon>
    </div>
  </div>
</template>

<script>
import MODULE_ID from '../moduleId';
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import index from '../index';
import configMixin from '@/mixins/configMixin';
import dutyMixin from '../common/dutyMixin';
import TimeLinePoint from '../../../components/decorators/TimeLinePoint.vue';

import DutyActivityEnd_Default from './tenantDutyActivityComponents/DutyActivityEnd_Default.vue';
import DutyActivityEnd_RhB from './tenantDutyActivityComponents/DutyActivityEnd_RhB.vue';
import DutyActivityEnd_CVAG from './tenantDutyActivityComponents/DutyActivityEnd_CVAG.vue';
import DutyActivityEnd_Blt from './tenantDutyActivityComponents/DutyActivityEnd_Blt.vue';
import DutyActivityEnd_JB from './tenantDutyActivityComponents/DutyActivityEnd_JB.vue';
import DutyActivityEnd_AAGL from './tenantDutyActivityComponents/DutyActivityEnd_AAGL.vue';

import DutyActivityNoLineEnd_Default from './tenantDutyActivityComponents/DutyActivityNoLineEnd_Default.vue';
import DutyActivityNoLineEnd_Dsw21 from '@/modules/myDuties/dutyActivities/tenantDutyActivityComponents/DutyActivityNoLineEnd_Dsw21.vue';
import DutyActivityNoLineEnd_RhB from './tenantDutyActivityComponents/DutyActivityNoLineEnd_RhB.vue';
import DutyActivityNoLineEnd_JB from './tenantDutyActivityComponents/DutyActivityNoLineEnd_JB.vue';
import DutyActivityNoLineEnd_AAGL from './tenantDutyActivityComponents/DutyActivityNoLineEnd_AAGL.vue';

import DutyActivityNoLineStart_Default from './tenantDutyActivityComponents/DutyActivityNoLineStart_Default.vue';
import DutyActivityNoLineStart_Dsw21 from '@/modules/myDuties/dutyActivities/tenantDutyActivityComponents/DutyActivityNoLineStart_Dsw21.vue';
import DutyActivityNoLineStart_RhB from './tenantDutyActivityComponents/DutyActivityNoLineStart_RhB.vue';
import DutyActivityNoLineStart_JB from './tenantDutyActivityComponents/DutyActivityNoLineStart_JB.vue';
import DutyActivityNoLineStart_AAGL from './tenantDutyActivityComponents/DutyActivityNoLineStart_AAGL.vue';

import DutyActivityStart_Default from './tenantDutyActivityComponents/DutyActivityStart_Default.vue';

import DutyActivityStart_Dsw21 from '@/modules/myDuties/dutyActivities/tenantDutyActivityComponents/DutyActivityStart_Dsw21.vue';
import DutyActivityStart_LVB from './tenantDutyActivityComponents/DutyActivityStart_LVB.vue';
import DutyActivityStart_RhB from './tenantDutyActivityComponents/DutyActivityStart_RhB.vue';
import DutyActivityStart_CVAG from './tenantDutyActivityComponents/DutyActivityStart_CVAG.vue';
import DutyActivityStart_Blt from './tenantDutyActivityComponents/DutyActivityStart_Blt.vue';
import DutyActivityStart_JB from './tenantDutyActivityComponents/DutyActivityStart_JB.vue';
import DutyActivityStart_AAGL from './tenantDutyActivityComponents/DutyActivityStart_AAGL.vue';

import DutyActivityTitle_Default from './tenantDutyActivityComponents/DutyActivityTitle_Default.vue';
import DutyActivityTitle_Dsw21 from '@/modules/myDuties/dutyActivities/tenantDutyActivityComponents/DutyActivityTitle_Dsw21.vue';
import DutyActivityTitle_LVB from './tenantDutyActivityComponents/DutyActivityTitle_LVB.vue';
import DutyActivityTitle_RhB from './tenantDutyActivityComponents/DutyActivityTitle_RhB.vue';
import DutyActivityTitle_CVAG from './tenantDutyActivityComponents/DutyActivityTitle_CVAG.vue';
import DutyActivityTitle_JB from './tenantDutyActivityComponents/DutyActivityTitle_JB.vue';
import DutyActivityTitle_AAGL from './tenantDutyActivityComponents/DutyActivityTitle_AAGL.vue';

import DutyCardTitle from '../components/DutyCardTitle.vue';
import DutyActivityEnd_Dsw21 from '@/modules/myDuties/dutyActivities/tenantDutyActivityComponents/DutyActivityEnd_Dsw21.vue';

const titleComponents = {
  default: DutyActivityTitle_Default,
  lvb: 'DutyActivityTitle_LVB',
  rhb: 'DutyActivityTitle_RhB',
  dsw21: 'DutyActivityTitle_Dsw21',
  cvag: 'DutyActivityTitle_CVAG',
  jb: 'DutyActivityTitle_JB',
  blt: DutyActivityTitle_Default,
  aagl: DutyActivityTitle_AAGL,
};
const startComponents = {
  default: 'DutyActivityStart_Default',
  lvb: 'DutyActivityStart_LVB',
  rhb: 'DutyActivityStart_RhB',
  dsw21: 'DutyActivityStart_Dsw21',
  cvag: 'DutyActivityStart_CVAG',
  jb: 'DutyActivityStart_JB',
  blt: DutyActivityStart_Blt,
  aagl: 'DutyActivityStart_AAGL',
};
const endComponents = {
  default: 'DutyActivityEnd_Default',
  rhb: 'DutyActivityEnd_RhB',
  dsw21: 'DutyActivityEnd_Dsw21',
  cvag: 'DutyActivityEnd_CVAG',
  jb: 'DutyActivityEnd_JB',
  blt: DutyActivityEnd_Blt,
  aagl: 'DutyActivityEnd_AAGL',
};
const noLineStartComponents = {
  default: 'DutyActivityNoLineStart_Default',
  rhb: 'DutyActivityNoLineStart_RhB',
  dsw21: 'DutyActivityNoLineStart_Dsw21',
  jb: 'DutyActivityNoLineStart_JB',
  aagl: 'DutyActivityNoLineStart_AAGL',
};
const noLineEndComponents = {
  default: 'DutyActivityNoLineEnd_Default',
  rhb: 'DutyActivityNoLineEnd_RhB',
  dsw21: 'DutyActivityNoLineEnd_Dsw21',
  jb: 'DutyActivityNoLineEnd_JB',
  aagl: 'DutyActivityNoLineEnd_AAGL',
};

export default {
  name: 'DutyActivity',
  mixins: [commonMixin, dateTimeMixin, configMixin, dutyMixin],
  props: {
    duty: Object,
    dutyActivity: Object,
    nextDutyActivity: Object,
    isCollapsed: { type: Boolean, default: false },
    isParent: { type: Boolean, default: false },
    showBottomBorder: { type: Boolean, default: true },
  },
  components: {
    DutyCardTitle,
    TimeLinePoint,

    DutyActivityTitle_Default,
    DutyActivityTitle_LVB,
    DutyActivityTitle_RhB,
    DutyActivityTitle_Dsw21,
    DutyActivityTitle_CVAG,
    DutyActivityTitle_JB,
    DutyActivityTitle_AAGL,

    DutyActivityStart_Default,
    DutyActivityStart_LVB,
    DutyActivityStart_RhB,
    DutyActivityStart_Dsw21,
    DutyActivityStart_CVAG,
    DutyActivityStart_JB,
    DutyActivityStart_AAGL,

    DutyActivityEnd_Default,
    DutyActivityEnd_RhB,
    DutyActivityEnd_Dsw21,
    DutyActivityEnd_CVAG,
    DutyActivityEnd_JB,
    DutyActivityEnd_AAGL,

    DutyActivityNoLineStart_Default,
    DutyActivityNoLineStart_RhB,
    DutyActivityNoLineStart_Dsw21,
    DutyActivityNoLineStart_JB,
    DutyActivityNoLineStart_AAGL,

    DutyActivityNoLineEnd_Default,
    DutyActivityNoLineEnd_RhB,
    DutyActivityNoLineEnd_Dsw21,
    DutyActivityNoLineEnd_JB,
    DutyActivityNoLineEnd_AAGL,
  },
  data() {
    return {
      isCollapsedInternal: this.isCollapsed,
    };
  },

  computed: {
    ...mapState(MODULE_ID, ['dutyStopsById']),
    locale() {
      return this.$store.state.language.locale;
    },
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    timeFormat() {
      return this.configuredTimeFormat;
    },
    titleComponent() {
      return titleComponents[this.tenant] ? titleComponents[this.tenant] : titleComponents.default;
    },
    startComponent() {
      return startComponents[this.tenant] ? startComponents[this.tenant] : startComponents.default;
    },
    endComponent() {
      return endComponents[this.tenant] ? endComponents[this.tenant] : endComponents.default;
    },
    noLineStartComponent() {
      return noLineStartComponents[this.tenant] ? noLineStartComponents[this.tenant] : noLineStartComponents.default;
    },
    noLineEndComponent() {
      return noLineEndComponents[this.tenant] ? noLineEndComponents[this.tenant] : noLineEndComponents.default;
    },
    style() {
      if (this.isParent) return 'padding-bottom:5px';
      let color = this.darkMode ? '#2a2a2a' : '#f4f4f4';
      return `background:${color};border-left:10px solid ${color};border-right:10px solid ${color}`;
    },
    hasTrueChildren() {
      return this.dutyActivity.children && this.dutyActivity.children.length > 1;
    },

    hasStartIdentifier() {
      return this.dutyStopsById[this.dutyActivity.startStopIdFk];
    },

    hasEndIdentifier() {
      return this.dutyStopsById[this.dutyActivity.endStopIdFk];
    },
  },
  methods: {
    toggleDutyActivity() {
      this.isCollapsedInternal = !this.isCollapsedInternal;
      console.debug('isCollapsedInternal', this.isCollapsedInternal);
      this.$emit('toggleCollapseState');
    },
    displayTrainTeam(trainNr, trainTeam) {
      console.debug('displayTrainTeam', trainNr, trainTeam);
      this.$emit('displayTrainTeam', trainNr, trainTeam);
    },
  },
};
</script>
<style scoped>
.toggle-da-btn {
  position: absolute;
  right: 17px;
  top: 70px;
}

.duty-activity-parent {
  /* font-size: 0.875rem !important; */
  font-size: 0.87em !important;
  font-weight: 400 !important;
  line-height: 1.375rem !important;
  letter-spacing: 0.0071428571em !important;
  padding-left: 14px;
  padding-right: 20px;
}

.duty-activity-child-light {
  border-bottom: 1px dotted #e0e0e0;
}

.duty-activity-child-dark {
  border-bottom: 1px dotted #404040;
}

.duty-activity-child-light,
.duty-activity-child-dark {
  /* font-size: 0.875rem !important; */
  font-size: 0.875em !important;
  font-weight: 300 !important;
  line-height: 1.375rem !important;
  letter-spacing: 0.0071428571em !important;
  padding: 5px 10px 5px 15px;
}
</style>
